import { Link } from 'react-router-dom'
import { NOT_FOUND_LABELS } from '../../common/constants/labels'

export default function NotFound() {
  return (
    <section className="bg-white dark:bg-gray-900 h-screen">
      <div className="py-8 px-4 mx-auto max-w-screen-xl h-screen flex justify-center items-center lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-white dark:text-primary-500">
            {NOT_FOUND_LABELS.ERROR_CODE}
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            {NOT_FOUND_LABELS.TITLE}
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">{NOT_FOUND_LABELS.DESCRIPTION}</p>
          <Link
            to="/"
            className="inline-flex text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
          >
            {NOT_FOUND_LABELS.BACK_BUTTON}
          </Link>
        </div>
      </div>
    </section>
  )
}
